<template>
    <div class="container">
        <van-empty description="抱歉，你访问的页面不存在。" />
    </div>
</template>


<style lang="less" scoped>
    .container {
        height: 90vh;
        margin: auto 0;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

<script>
    import Vue from 'vue';
    import {
        Empty
    } from 'vant';

    Vue.use(Empty);
    export default {

    }
</script>